<body class="gray-bg">
  <div class="middle-box text-center animated fadeInDown">
    <h1>403</h1>
    <h3 class="font-bold">Forbidden</h3>
    <div *ngIf="useDefaultMessage" class="error-desc m-b">
      You do not have a permission to perform this action.
      <br />
    </div>
    <div *ngIf="!useDefaultMessage" class="error-desc m-b">
      You do not have a permission to access this {{ backUrl ? backUrl.slice(0, -1) : 'resource' }}.
      <br />
    </div>
    <shared-ui-buttons-button [type]="buttonType.Primary" [text]="'Back'" (action)="navigateBack()"></shared-ui-buttons-button>
  </div>
</body>
